import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
    // tslint:disable-next-line:component-selector
    selector: "formly-field-surveyhidden",
    template: `HIDDEN`,
    standalone: false
})
export class FormlyFieldSurveyHiddenComponent extends FieldType<FieldTypeConfig> {}
